export function userHasPermission(permissions, key) {
  if (!key) return true;
  const list = Array.isArray(permissions) ? permissions : [];
  return list.includes(key);
}

export function userHasAnyPermission(permissions, keys = []) {
  if (!keys.length) return true;
  return keys.some((k) => userHasPermission(permissions, k));
}

const WORKSPACE_ADMIN_ROLES = new Set([
  'PLATFORM ADMINISTRATOR',
  'SYSTEM ADMINISTRATOR',
  'TENDER ADMINISTRATOR'
]);

export function isWorkspaceAdmin(roles) {
  const list = Array.isArray(roles) ? roles : [];
  return list.some((role) => WORKSPACE_ADMIN_ROLES.has(String(role || '').trim().toUpperCase()));
}

export function canManageMasters(permissions, roles) {
  return userHasPermission(permissions, 'tender.masters.manage')
    || userHasPermission(permissions, 'masters.view')
    || isWorkspaceAdmin(roles);
}
